import React, { FC } from 'react';
import { Card, CardContent, CardHeader, Grid, IconButton } from '@material-ui/core';
import { InfoIcon, LightTooltip } from '../../../../components';
import { useStyles } from './styles';
import { formatNumber } from '../../../../utils';

interface Props {
  title: string;
  translation: any;
  tooltip: string;
  currency?: string;
  firstValue: number;
  firstPercentage: number;
  secondValue: number;
  secondPercentage: number;
  selected: boolean;
  onClick: () => void;
}

export const CPQuickReport: FC<Props> = ({ title, translation, tooltip, currency, firstValue, firstPercentage, secondValue, secondPercentage, selected, onClick }) => {
  const classes = useStyles();

  return (
    <Card className={`${classes.root} ${selected && classes.selected}`} onClick={onClick}>
      <CardHeader
        action={
          <LightTooltip title={tooltip} arrow placement="right-start">
            <IconButton size="small">
              <InfoIcon />
            </IconButton>
          </LightTooltip>
        }
        title={title}
      />
      <CardContent className={classes.doublePanelPadding}>
        <span className={classes.percentContent}>{currency ? formatNumber(firstValue, currency) : firstValue}</span>/<span className={classes.percentContentSecond}>{`${secondValue.toFixed(2)} ${translation.text_886}`}</span>
        <Grid className={classes.bottomContent}>
          <Grid className={`${classes.bottomContentItem} ${firstPercentage > 0 ? classes.up : firstPercentage !== 0 && classes.down}`}>
            {firstPercentage > 0
              ? firstPercentage < 100
                ? `+${Number.isInteger(firstPercentage) ? firstPercentage : firstPercentage.toFixed(2)}%`
                : '>+100%'
              : firstPercentage < 0
              ? firstPercentage > -100
                ? `${Number.isInteger(firstPercentage) ? firstPercentage : firstPercentage.toFixed(2)}%`
                : '<-100%'
              : `${firstPercentage}%`}
          </Grid>
          <Grid className={`${classes.bottomContentItem} ${secondPercentage > 0 ? classes.up : secondPercentage !== 0 && classes.down}`}>
            {secondPercentage > 0
              ? secondPercentage < 100
                ? `+${Number.isInteger(secondPercentage) ? secondPercentage : secondPercentage.toFixed(2)}%`
                : '>+100%'
              : secondPercentage < 0
              ? secondPercentage > -100
                ? `${Number.isInteger(secondPercentage) ? secondPercentage : secondPercentage.toFixed(2)}%`
                : '<-100%'
              : `${secondPercentage}%`}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
